import { BoardState, Move, PieceType, Square } from '@draughts/shared';
import { getPieceAt } from '../board/board-utils.js';
import { getSimpleMoves, getKingMoves } from './simple-moves.js';
import { getCaptureMoves } from './capture-moves.js';

/**
 * Le mosse che si possono ACCODARE come pre-mossa per il pezzo su `square`: le sue mosse
 * vere nella posizione attuale, senza l'obbligo di presa — né fra pezzi diversi né per
 * questo pezzo, quindi quiete E prese, entrambe. L'obbligo è la sola cosa che una
 * pre-mossa non può conoscere, perché la mossa avversaria lo cambia; tutto il resto
 * (occupazione, direzioni della variante, dama volante, coup turc, promozione) viene dai
 * generatori veri.
 *
 * Al posto di un generatore di sola GEOMETRIA (com'era `getPremoveDestinations`), che
 * offriva gli arrivi di presa a due caselle anche quando sulla casella saltata non c'era
 * nessuno e gli arrivi su caselle occupate: pallini che non avevano rapporto con la
 * posizione e che, indistinguibili da una mossa quieta, dicevano il falso.
 *
 * Attenzione a cosa NON è: non è l'insieme delle destinazioni *accettate*. Una pre-mossa
 * è solo un intento `(from, to)`, e chi gioca può accodare anche un arrivo che oggi non è
 * raggiungibile (l'arrivo lontano di una presa multipla che nascerà, una casella che
 * l'avversario sta per liberare). Quello che questo elenco decide è cosa la damiera
 * SUGGERISCE, non cosa permette.
 *
 * Non usare `getLegalMovesForPiece`: passa da `getAllLegalMoves` e quindi applica
 * l'obbligo. Per lo stesso motivo la regola frisone della dama bloccata
 * (`applyBlockedKingRule`, interna a `getAllLegalMoves`) qui non si applica: una
 * pre-mossa che la viola viene scartata al cambio di turno come qualunque altra
 * diventata illegale.
 */
export function getPremoveMoves(board: BoardState, square: Square): Move[] {
  const piece = getPieceAt(board, square);
  if (!piece) return [];

  const captures = getCaptureMoves(board, square);
  const quiet = piece.type === PieceType.MAN
    ? getSimpleMoves(board, square)
    : getKingMoves(board, square);

  return [...captures, ...quiet];
}
